import apiAuth from "@/services/http/apiAuth";

/**
 * GET /admin/activity
 *
 * Devuelve los últimos movimientos del admin para el QuickActions dock.
 * Estructura esperada:
 *   { items: [{ key, type, icon, title, shortTitle, link, timestamp }, ...] }
 *
 * Las categorías (news, club, event) son opcionales: si el backend no
 * encuentra datos para una, simplemente no la incluye. El dock degrada
 * mostrando solo el botón "Panel".
 */
export async function getRecentActivity() {
  const res = await apiAuth.get("/admin/activity");
  return res.data; // { items: [...] }
}
